const modifiers = {
  en: require('./en').default
}

export default modifiers
